<template>
  <el-form ref="form" label-width="100px" style="margin-right: 100px;" :model="model" :rules="rules">
    <el-form-item label="模型索引" prop="key">
      <el-input v-model="model.key"></el-input>
    </el-form-item>
    <el-form-item label="模型原图" prop="image">
      <image-select @select="select"></image-select>
    </el-form-item>
    <el-form-item label="保存原图" prop="saveImage">
      <el-switch v-model="model.saveImage"></el-switch>
    </el-form-item>
    <el-form-item align="center">
      <el-button @click="$refs.form.resetFields()">重 置</el-button>
      <el-button @click="sumbit" type="primary">提 交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import ImageSelect from "@/components/image-select.vue";
import { rules } from "@/utils";

export default {
  props: {
    bucket: {
      type: Number,
      required: true
    }
  },
  components: {
    ImageSelect
  },
  data() {
    return {
      model: {
        bucket: this.bucket,
        key: "",
        image: null,
        saveImage: true
      },
      rules: {
        key: [rules.required()],
        image: [rules.required()]
      }
    };
  },
  methods: {
    select(files) {
      let f = files[0];
      this.model.key = f.name;
      this.model.image = f;
    },
    async sumbit(files) {
      let ok = await this.$refs.form.validate();
      if (!ok) return;

      let res = await this.$request(this.$api.model.save(this.model));

      this.$message.success("模型新增成功");
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style>
</style>
